module.exports = __webpack_public_path__ + "static/tartaglia-banner-d4358504cc735061a8c74443567b5cb4.png";